// 俄语(Russian
export default {
  coinSpecialOffer: "Акция для пополнения монет HT",
  buySomeAndGetExtra: "Купите немного и получите больше!",
  balance: "Баланс",
  coins: "{number} монет(ы)",
  coin: "{number} монета",
  extraCoins: "{number} бонусных монет",
  continue: "Продолжить",
  byToppingUpYouAgree: "Пополняя счет, Вы соглашаетесь с договором",
  topUpAgreement: "[Договор пополнения]",
  htCoin: "Монета HT",
  scanCodeToLog: "Сканируйте код для входа",
  bindYourHelloTalkAccount:
    "Используйте приложение HelloTalk для сканирования кода и входа в систему. Привяжите свою учетную запись HelloTalk и пополните счет.",
  itemSelection: "Выбор товара",
  paymentAmount: "Сумма",
  topUpSuccessful: "Пополнение успешно👏",
  totalCoinsNumber:
    "Вы успешно добавили {numberone} монет и получили {numbertwo} дополнительных монет, всего {numberall} монет(ы).",
  ok: "OK",
  copyLinkToPay:
    "Пожалуйста, скопируйте ссылку и откройте ее в приложении HelloTalk, чтобы завершить оплату.",
  paymentFailed: "Платеж не прошел",
  creditCardPay: "Оплатить с помощью PayPal или кредитной карты",
  creditCard: "Кредитная карта",
  payssion: {
    // key:value
    purchaseSucceeded: "Покупка успешна",
    topUpSuccessful: "Пополнение успешно",
    paymentFailed: "Платеж не прошел",
    recharge: "Пополнение",
    VipRecharge: "VIP-пополнение",
    rechargeWithCoins: "Пополнить HT-монеты",
    oneMonthMember: "Месячное членство",
    annualFeeMember: "Годовое членство",
    oneTimePurchase: "пожизненное членство",
    coins: "{number} монет HT",
    coin: "{number} монета HT",
    extraCoins: "{number} бонусных монет HT",
    extraCoin: "{number} бонусная монета HT",
    continue: "Продолжить",
    byToppingUpYouAgree: "Пополняя счет, Вы соглашаетесь с",
    rechargePrompt:
      "Напоминание: несовершеннолетние должны получить разрешение родителей или быть в сопровождении опекуна",
    toppingUpYouAgree: "[Соглашение о Пополнении]",
  },
};
